"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _IT5KI7HRcjs = require('../__chunks/IT5KI7HR.cjs');
require('../__chunks/LH55DG7M.cjs');
require('../__chunks/XRATBFDX.cjs');


var _UCZW3OGHcjs = require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');


var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/form/form-radio-group.tsx
var _jsxruntime = require('react/jsx-runtime');
var TagName = "div";
var useFormRadioGroup = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useFormRadioGroup2({ store, ...props }) {
    props = _3BSDKDKDcjs.useWrapElement.call(void 0, 
      props,
      (element) => /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _UCZW3OGHcjs.CompositeScopedContextProvider, { value: void 0, children: element }),
      []
    );
    props = { role: "radiogroup", ...props };
    props = _IT5KI7HRcjs.useFormGroup.call(void 0, props);
    return props;
  }
);
var FormRadioGroup = _PTOCUU2Dcjs.forwardRef.call(void 0, function FormRadioGroup2(props) {
  const htmlProps = useFormRadioGroup(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.FormRadioGroup = FormRadioGroup; exports.useFormRadioGroup = useFormRadioGroup;
